/**
 * Bookings API Module
 * Customer booking requests, cart management, and vendor booking queue.
 */

import { api } from './client'

export const bookingAPI = {
  // Customer booking operations
  createBooking: (data) => api.post('/bookings', data),
  getBookings: (params) => api.get('/bookings', { params }),
  getBooking: (id) => api.get(`/bookings/${id}`),

  // Individual booking status (admin / edge cases)
  updateBookingStatus: (id, status, cancellationReason) =>
    api.patch(`/bookings/${id}/status`, { status, cancellation_reason: cancellationReason }),

  // Group status — vendor advances and customer order cancellations
  updateGroupStatus: (groupId, status, cancellationReason) =>
    api.patch(`/booking-groups/${groupId}/status`, { status, cancellation_reason: cancellationReason }),

  // Cart operations
  getCart: (entityId) => api.get(`/cart/${entityId}`),
  addCartItem: (entityId, item) => api.post(`/cart/${entityId}/items`, item),
  removeCartItem: (entityId, itemId) => api.delete(`/cart/${entityId}/items/${itemId}`),
  clearCart: (entityId) => api.delete(`/cart/${entityId}`),

  // Vendor booking queue
  getVendorBookings: (entityId, params) =>
    api.get(`/vendor/entities/${entityId}/bookings`, { params }),
}
